import Icon from 'components/shared/Icon'
import notificationToast from 'helpers/notificationToast'
import { toast } from 'react-toastify'

export default function CopyButton ({ shareUrl }: { shareUrl: string }): JSX.Element {
  return (
    <button
      className='hs8 w8 pa0 br2 bg-white hover-bg-ghost-white flex items-center justify-center precedents-blue pointer'
      onClick={() => {
        notificationToast(<Icon name='icon-link' />, toast.TYPE.SUCCESS, 'Link copied to clipboard')
      }}
      data-clipboard-text={shareUrl}
    >
      <Icon name='icon-link' className='hs7 w7' />
    </button>
  )
}
